import { pushEvent } from '../../../../client/data-layer';
import { Category } from './types';

/**
 * Tracks a click on a category in the mega menu. `depth` is the 0-based depth
 * of the category within the category tree.
 */
export const trackCategoryClick = (category: Category, depth: number) => {
  pushEvent('megaMenuCategoryClick', {
    depth,
    category,
  });
};
